'use client';

import clsx from 'clsx';
import { FC } from 'react';
import Icon from '~/components/icon';

import { useCity } from '../context';
import styles from './styles.module.css';

interface Props {
  onSelect: () => void;
}

const CityMobileSelect: FC<Props> = ({ onSelect }) => {
  const { cities, selectedCity, getCityHref } = useCity();

  return (
    <ul className={styles.list}>
      {cities.map((city) => {
        const isActive = city.id === selectedCity.id;

        const optionClassName = clsx(styles.option, isActive && styles.active);

        return (
          <li key={city.id}>
            {isActive ? (
              <span aria-current="page" className={optionClassName}>
                <Icon name="check" className={styles.checkIcon} />
                <span>{city.title}</span>
              </span>
            ) : (
              <a href={getCityHref(city.id)} onClick={onSelect} className={optionClassName}>
                <span>{city.title}</span>
              </a>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default CityMobileSelect;
